import { useAppActions } from 'reducers/slices/offeringsSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadOfferings } = useAppActions();
  const { loading, offerings } = useSelector(state => state.offeringsSlice);

  return {
    loadOfferings,
    loading,
    offerings,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useOfferings.js